export const INDIA_LANGUAGE_VALUE = 'en-IN';
export const US_LANGUAGE_VALUE = 'en-US';

export const INDIA_WEBSITE_VALUE = 'IN';
export const US_WEBSITE_VALUE = 'US';
export const AE_WEBSITE_VALUE = 'AE';

export const DETAIL_PAGE_NAME = 'DETAILS';
export const REVIEW_PAGE_NAME = 'REVIEW';
export const COLLECTION_PAGE_NAME = 'COLLECTION';

export const ZC_PLAN = 'ZC';
export const FLEXI_DATE_PLAN = 'FlexiDate';

export const ZC_ENUM = {
  ZC: 'zc',
  FlexiDate: 'flexi',
};
export const APPLY = 'APPLY';
export const REMOVE = 'REMOVE';
export const CMP_DETAILS_KEY = 'campaignDetails';

export const MONTHS = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

export const MONTHS_CAP = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const SHOW_DIY_CARD = {
  STRIP: 'strip',
  CARD: 'card',
  HIDE: 'hide',
};

export const DIY_ACTIVITES_V1 = [
  'Must See',
  'Romantic',
  'Historic',
  'Adventure',
  'Kid Friendly',
  'Senior',
];

export const DIY_ACTIVITES_V2 = [
  'Must See',
  'Romantic',
  'Historic',
  'Adventure',
  'For Friends',
  'Kid Friendly',
  'For Seniors',
  'Pilgrimage',
];

export const DATE_FORMAT = {
  DAY_MMM_DD_YYYY: 'DAY, MMM DD, YYYY',
  DAY_MMM_DD: 'DAY, MMM DD',
  YYYY_MM_DD: 'YYYY-MM-DD',
};
